var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelivered4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.3307 22.0003C40.3307 32.1203 32.1174 40.3337 21.9974 40.3337C11.8774 40.3337 5.69906 30.1403 5.69906 30.1403M5.69906 30.1403H13.9857M5.69906 30.1403V39.307M3.66406 22.0003C3.66406 11.8803 11.8041 3.66699 21.9974 3.66699C34.2257 3.66699 40.3307 13.8603 40.3307 13.8603M40.3307 13.8603V4.69366M40.3307 13.8603H32.1907",
    stroke: "#219EBC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivered4);
export default __webpack_public_path__ + "static/media/delivered4.86d1bfe762f76dcd09d087d9561676f5.svg";
export { ForwardRef as ReactComponent };